import { Plan } from '../api';

function calculatePricePerCheck(item: Plan): number {
  const price = Number(item.price);
  const value = Number(item.value);
  const oldPrice = Number(item.old_price);
  return (!oldPrice ? price : oldPrice) / value;
}

export default calculatePricePerCheck;
